
import { connect } from "react-redux";
import ToolTipComponent from "../components/ToolTipComponent";

const mapStateToProps = (state, ownProps) => ({
  
})

const mapDispatchToProps = ({
  
})

const ToolTip = connect(
  mapStateToProps,
  mapDispatchToProps
)(ToolTipComponent)

export default ToolTip



// WEBPACK FOOTER //
// ./src/containers/ToolTip.js